import React from "react";
import {ReactComponent as TippingLogo} from "assets/images/logo2023client.svg";
import {ReactComponent as TippingResponsiveLogo} from "assets/images/logoResponsive2023client.svg";
import {isMobile} from "react-device-detect";
import styled from "styled-components";
import {Link} from "react-router-dom";

const LogoWrapper = styled(Link)`
	display: flex;
	align-items: center;
	svg {
		height: 48px;
	}
`;

export const Logo: React.FC = () => {
	return (
		<LogoWrapper to="/predictor">
			{!isMobile ? <TippingLogo /> : <TippingResponsiveLogo />}
		</LogoWrapper>
	);
};
